import script from "./FontAwesome.vue?vue&type=script&setup=true&lang=js"
export * from "./FontAwesome.vue?vue&type=script&setup=true&lang=js"

import "./FontAwesome.vue?vue&type=style&index=0&id=17153572&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17153572"]])

export default __exports__